import React, { useState, useEffect } from "react";

const MobileBottomNav = ({ leftItems = [], addMenuItems = [], notificationConfig = null, onAddClick = null }) => {
  const [showAddMenu, setShowAddMenu] = useState(false);
  const [showNotifMenu, setShowNotifMenu] = useState(false);
  const [activeNotifPanel, setActiveNotifPanel] = useState(null);

  const isAnyOpen = showAddMenu || showNotifMenu || !!activeNotifPanel;

  useEffect(() => {
    if (isAnyOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isAnyOpen]);

  const closeAll = () => {
    setShowAddMenu(false);
    setShowNotifMenu(false);
    setActiveNotifPanel(null);
  };

  const handleAddToggle = () => {
    if (onAddClick) {
      onAddClick();
      return;
    }
    setShowAddMenu((prev) => !prev);
    setShowNotifMenu(false);
    setActiveNotifPanel(null);
  };

  const handleNotifToggle = () => {
    if (activeNotifPanel) return;
    setShowNotifMenu((prev) => !prev);
    setShowAddMenu(false);
  };

  const handleNotifItemClick = (item) => {
    setShowNotifMenu(false);
    setActiveNotifPanel(item.panelKey);
    item.onOpen?.();
  };

  const isNotifActive = showNotifMenu || !!activeNotifPanel;
  const hasNotifBadge = notificationConfig?.totalBadge > 0;

  return (
    <div className="mobile-bottom-nav">
      {isAnyOpen && (
        <div className="mobile-bottom-nav-overlay" onClick={closeAll} />
      )}

      {activeNotifPanel && notificationConfig?.panels?.[activeNotifPanel] && (
        <div className="mobile-bottom-nav-notif-panel">
          <button
            className="mobile-bottom-nav-panel-close"
            onClick={closeAll}
            type="button"
            aria-label="Close"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M15 5L5 15M5 5L15 15"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          {notificationConfig.panels[activeNotifPanel]}
        </div>
      )}

      <div className="mobile-bottom-nav-bar">
        {leftItems.map((item, i) => (
          <button
            key={`l-${i}`}
            className={`mobile-bottom-nav-item ${item.isActive ? "active" : ""}`}
            onClick={() => { if (!item.isActive) item.onClick?.(); }}
            type="button"
          >
            <div className="mobile-bottom-nav-icon">
              <img src={item.icon} alt={item.label} />
            </div>
            <span>{item.label}</span>
          </button>
        ))}

        <div className="mobile-bottom-nav-center">
          {showAddMenu && (
            <div className="mobile-bottom-nav-popup">
              {addMenuItems.map((item, i) => (
                <button
                  key={`a-${i}`}
                  className={`mobile-bottom-nav-popup-item ${item.isActive ? "active" : ""}`}
                  onClick={() => {
                    if (!item.isActive) item.onClick?.();
                    setShowAddMenu(false);
                  }}
                  type="button"
                >
                  <div className="mobile-bottom-nav-icon">
                    <img src={item.icon} alt={item.label} />
                  </div>
                  <span>{item.label}</span>
                </button>
              ))}
            </div>
          )}
          <button
            className={`mobile-bottom-nav-add ${showAddMenu || onAddClick ? "active" : ""}`}
            onClick={handleAddToggle}
            type="button"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 5V19M5 12H19"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <span className="mobile-bottom-nav-label">Add</span>
        </div>

        {notificationConfig && (
          <div className="mobile-bottom-nav-alert-wrap">
            {showNotifMenu && (
              <div className="mobile-bottom-nav-popup">
                {notificationConfig.items.map((item, i) => (
                  <button
                    key={`n-${i}`}
                    className="mobile-bottom-nav-popup-item"
                    onClick={() => handleNotifItemClick(item)}
                    type="button"
                  >
                    <div className="mobile-bottom-nav-icon">
                      <img src={item.icon} alt={item.label} />
                    </div>
                    <span>{item.label}</span>
                    {item.badge > 0 && (
                      <span className="mobile-bottom-nav-popup-badge">{item.badge}</span>
                    )}
                  </button>
                ))}
              </div>
            )}
            <button
              className={`mobile-bottom-nav-item ${isNotifActive ? "active" : ""}`}
              onClick={handleNotifToggle}
              type="button"
            >
              <div className="mobile-bottom-nav-icon position-relative">
                <img src={notificationConfig.icon} alt="Alerts" />
                {hasNotifBadge && <span className="mobile-bottom-nav-badge-dot" />}
              </div>
              <span>Alerts</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileBottomNav;
